<div class="wrapper" [style.width]="size()" [style.height]="size()">
    <svg viewBox="0 0 100 100">
        <defs>
            @for (item of strokes; track item) {
                @if (item.colorEnd) {
                    <linearGradient [attr.id]="item.gradientId" gradientUnits="userSpaceOnUse"
                        [attr.x1]="item.gradientX1" [attr.y1]="item.gradientY1"
                        [attr.x2]="item.gradientX2" [attr.y2]="item.gradientY2">
                        <stop offset="0%" [attr.stop-color]="item.colorStart" />
                        <stop offset="100%" [attr.stop-color]="item.colorEnd" />
                    </linearGradient>
                }
            }
        </defs>
        @for (item of strokes; track item) {
        <ng-container>
            <circle pathLength="100"
            [attr.cx]="50"
            [attr.cy]="50"
            [attr.r]="radius()"
            [attr.stroke-dasharray]="item.dashArray"
            [attr.stroke-dashoffset]="item.offset"
            [attr.stroke]="item.colorEnd ? 'url(#' + item.gradientId + ')' : item.stroke"
            [attr.stroke-width]="maxStrokeWidth()"
            [style.transition]="'stroke-dasharray linear ' + item.transitionTimeMs + 'ms'"> </circle>
        </ng-container>
        }
    </svg>
    <div class="content-wrapper">
        <div>
            <ng-content></ng-content>
        </div>
    </div>
</div>